import React from 'react';
import { IconProps } from './interface';

const ValidationIcon: React.FC<IconProps> = ({ hasError, wasTouched }) => {
  if (wasTouched && hasError) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" className="validation-icon icon-wrong" viewBox="0 0 62 62">
        <path d="M31.622.71c-16.85 0-30.5 13.65-30.5 30.501 0 16.85 13.66 30.5 30.5 30.5s30.5-13.65 30.5-30.5-13.66-30.5-30.5-30.5zm15.18 42.151l-3.54 3.54-11.64-11.66-11.65 11.66-3.54-3.54 11.65-11.65-11.65-11.65 3.54-3.54 11.66 11.65 11.65-11.65 3.54 3.54-11.67 11.65z"></path>
      </svg>
    );
  }
  return (
    <svg
      viewBox="0 0 62 62"
      className={`validation-icon ${wasTouched ? 'icon-valid' : ''}`}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M31.055.643c-16.85 0-30.5 13.65-30.5 30.5s13.65 30.5 30.5 30.5 30.5-13.65 30.5-30.5-13.66-30.5-30.5-30.5zm-4.99 44.05l-11.76-11.77 3.54-3.54 8.23 8.23 18.23-18.23 3.54 3.54z"></path>
    </svg>
  );
};

export default ValidationIcon;
